/**
 * Error Fallback Component for Sentry ErrorBoundary
 * Displayed when an unhandled error occurs in the React tree
 *
 * #1123: görünüm ortak durum ekranına (StatusScreen "error") taşındı; davranış aynı —
 * "Tekrar Dene" sınırı sıfırlar, "Sayfayı Yenile" sayfayı yeniden yükler, "Bu sorunu bildir"
 * ortak destek penceresini açar, hata ayrıntısı yalnız geliştirme ortamında görünür.
 * Bu bileşen yönlendiricinin (router) DIŞINDA çizilir: içinde `Link` kullanılmaz.
 */

import { ContextualSupportLink } from '@/components/feedback/contextual-support-link'
import { StatusScreen } from '@/components/status-screen/status-screen'
import { Button } from '@/components/ui/button'

interface ErrorFallbackProps {
  error: Error
  componentStack: string | null
  eventId: string | null
  resetError: () => void
}

export function ErrorFallback({
  error,
  resetError,
}: ErrorFallbackProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <StatusScreen
        variant="error"
        title="Bir şeyler ters gitti"
        description="Sorun bizde. Sayfayı yeniden denemek çoğu zaman yeter; sürerse bize haber ver."
        actions={
          <>
            <Button onClick={resetError}>Tekrar Dene</Button>
            <Button variant="outline" onClick={() => window.location.reload()}>
              Sayfayı Yenile
            </Button>
          </>
        }
        footer={
          <div className="flex flex-col items-center gap-3">
            <ContextualSupportLink source="root-error" />
            {import.meta.env.DEV && (
              <details className="w-full max-w-md rounded border bg-muted p-3 text-left text-xs">
                <summary className="cursor-pointer font-medium">
                  Hata Detayları (Dev)
                </summary>
                <pre className="mt-2 overflow-auto whitespace-pre-wrap text-destructive">
                  {error.message}
                </pre>
              </details>
            )}
          </div>
        }
      />
    </div>
  )
}
